import supabase from '../supabase/supabase';

/**
 * Service to keep Supabase project active.
 * Supabase free tier pauses projects after 1 week of inactivity.
 * This pings a lightweight table every 24 hours.
 */
export const initKeepAlive = () => {
  const PING_INTERVAL = 24 * 60 * 60 * 1000; // 24 hours
  
  const performPing = async () => {
    try {
      console.log('[PingService] Keeping Supabase awake...');
      // Perform a lightweight query on any public table
      const { data, error } = await supabase
        .from('profiles')
        .select('id')
        .limit(1);
        
      if (error) throw error;
      console.log('[PingService] Heartbeat successful');
    } catch (err) {
      console.error('[PingService] Heartbeat failed:', err.message);
    }
  };

  // Initial ping on load
  performPing();

  // Set interval
  const interval = setInterval(performPing, PING_INTERVAL);
  
  return () => clearInterval(interval);
};